import { Fragment } from "react";

function TagContainer ({ tags }) {
    return(
        <Fragment> 
            {tags 
                ?     
                <div className="flex flex-wrap lg:justify-start lg:content-start justify-end content-start lg:justify-self-end m-2 p-0.5 h-auto rounded">
                    {tags.map((tag) => (
                        <TagItem key={tag} tag={tag} />
                    ))}
                </div>
            
                : null}
        </Fragment>
    )
}

function TagItem ({ tag }) {
    return (
        <Fragment>
                <div className="antialiased uppercase text-xs text-coolGray-600 font-medium bg-cyan-400 w-auto max-h-5 px-2 py-0.5 m-1 rounded shadow-lg">{tag}</div>
         </Fragment>
    )
}

export { TagContainer }